export default function() {
  const mobileButton = document.querySelector(".js-mobile-nav");

  const toggleMobileNav = function() {
    document.querySelector(".js-mobile-menu").classList.toggle('is-opened');
  }

  mobileButton.addEventListener("click", toggleMobileNav, false);
}
